import { Head } from '@inertiajs/react';
import { Mail, MessageCircle, Phone } from 'lucide-react';

export default function Contact() {
  return (
    <>
      <Head title="Contact - Ethos Santé" />
      
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* En-tête */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Contactez-nous
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Notre équipe est à votre disposition pour répondre à toutes vos questions concernant Ethos Santé.
            </p>
          </div>

          {/* Cartes de contact */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {/* Email */}
            <div className="bg-white rounded-xl shadow-md p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-center w-16 h-16 bg-[#008788]/10 rounded-full mb-6 mx-auto">
                <Mail className="h-8 w-8 text-[#008788]" />
              </div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-3 text-center">
                Email
              </h2>
              <p className="text-gray-600 mb-4 text-center">
                Pour toute demande d'information, question ou suggestion
              </p>
              <div className="text-center">
                <a 
                  href="mailto:contact@ethosante.fr"
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#008788] hover:bg-[#00bcbe] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#008788] transition-colors"
                >
                  contact@ethosante.fr
                </a>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="bg-white rounded-xl shadow-md p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6 mx-auto">
                <MessageCircle className="h-8 w-8 text-green-600" />
              </div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-3 text-center">
                WhatsApp Business
              </h2>
              <p className="text-gray-600 mb-4 text-center">
                Contactez-nous rapidement via WhatsApp
              </p>
              <div className="text-center">
                <a 
                  href="https://wa.me/33458141597"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                >
                  <Phone className="h-5 w-5 mr-2" />
                  04 58 14 15 97
                </a>
              </div>
            </div>
          </div>

          {/* Section informative */}
          <div className="bg-white rounded-xl shadow-md p-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">
              Pourquoi nous contacter ?
            </h2>
            <div className="space-y-4 text-gray-600">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 mt-2 bg-[#008788] rounded-full mr-3"></div>
                <p>
                  <strong className="text-gray-900">Pour les patients :</strong> Questions sur l'utilisation de la plateforme, aide pour trouver un kinésithérapeute, informations sur les profils approuvés
                </p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 mt-2 bg-[#008788] rounded-full mr-3"></div>
                <p>
                  <strong className="text-gray-900">Pour les kinésithérapeutes :</strong> Inscription sur la plateforme, gestion de votre profil, informations sur la certification Ethos
                </p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-2 h-2 mt-2 bg-[#008788] rounded-full mr-3"></div>
                <p>
                  <strong className="text-gray-900">Pour les professionnels de santé :</strong> Partenariats, informations sur nos services, collaboration
                </p>
              </div>
            </div>
          </div>

          {/* Horaires de réponse */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Nous nous efforçons de répondre à toutes les demandes dans les meilleurs délais.
              <br />
              Temps de réponse moyen : 24-48 heures ouvrées.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}



